import { Box, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core'
import { Edit } from '@material-ui/icons';
import MROButton from 'components/buttons';
import FileUpload from 'components/form_components/fileUpload';
import GetInfoCard from 'components/GetInfoCard';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import { ToastMessageContext } from 'lib/contexts/message_context';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import ScopeDialog from 'views/Compliance/Approvals/Capability/ScopeDialog'
import { getOrganisationId } from 'lib/utils/common_utils';
import React, { useContext, useEffect, useState } from 'react'
import { BASE_API_URL_BOXP, BASE_API_URL_BOXR } from 'lib/constants';
import { WorkOrderServices } from 'lib/services/api/operaitons/lineMaintenance/workOrder/workOrder';



const useStyles = makeStyles((theme) => ({
    bodyText: {
        fontSize: 18,
        // lineHeight: "28px",
        paddingRight: "20px",
        paddingLeft: "5px"
    },
    partCard: {
        borderRadius: "8px",
        padding: "12px 4px",
        "& p": {
            fontSize: "14px",
            padding: "5px",
        },
    },
    actionButtons: {
        paddingTop: "5px",
        paddingBottom: "20px",
        textAlign: "right",
        marginRight: "20px",
        "& button:not(:last-child)": {
            marginRight: "20px",
        },
    },
}));


function TraceDocuments(props) {

    const classes = useStyles()
    const { open, handleClose, id, currentSelection, setIsRefreshTable, writePermission } = props
    const [boolState, setBoolState] = useState(false);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true)
    const [files, setFiles] = useState([])
    const [details, setDetails] = useState({})
    const message = useContext(ToastMessageContext)



    useEffect(() => {
        if (currentSelection !== undefined) {
            setFiles(currentSelection?.documents)
        }

    }, [currentSelection])


    const deleteFileHandler = async (id) => {
        setLoading("file-deleting");
        try {
            const response = await WorkOrderServices.deleteDocument({ id: id })

            if (response.success) {
                message.showToastMessage({
                    message: "File deleted successfully",
                    variant: "success",
                });


            }
            setLoading(null);
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
            setLoading("file-deleting-error");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        // formData.append("task_id", currentSelection?.id);
        if (records.length > 0) {
            records.forEach((item) => formData.append("documents[]", item));

            formData.append("id", currentSelection?.id);
            formData.append("organisation_id", getOrganisationId());

            setLoading("file_upload")
            PartSalesServices.updateSubCoreTraceItem(formData)
                .then((res) => {
                    message.showToastMessage({
                        message: " File added successfully",
                        variant: "success",
                    });
                    handleClose();;
                })
                .catch((err) => {
                    message.showToastMessage({
                        message: "Something went wrong",
                        variant: "error",
                    });
                })
                .finally(() => {
                    setLoading(null);
                });
        }
        else {
            handleClose();
        }

    };




    return (
        <ScopeDialog
            open={open}
            handleClose={handleClose}
            width="700px"
            notShowButton={true}
        >
            <Box display={"flex"} justifyContent="space-between" mb="15px" mt={'5px'}>
                <Box display={"flex"}>
                    <Typography color="primary" className={classes.bodyText}>
                        Trace Documents
                    </Typography>
                    {!boolState && writePermission ? <IconButton onClick={() => {
                        setBoolState(true)

                    }}>

                        <Edit htmlColor={ICON_COLOUR} style={{ fontSize: '15px' }} />
                    </IconButton> : " "}
                </Box>

            </Box>
            <form noValidate onSubmit={handleSubmit}>
                <FileUpload
                    isLoading={loading === "uploading"}
                    defaultValue={files.length > 0 && files !== undefined ? files?.map((file) => ({
                        filename: file?.filename,
                        url: file?.url,
                        id: file?.id,
                    })) : ''}
                    setFiles={(files) => {
                        setRecords(files);
                    }}
                    accept={"multiple"}
                    onDelete={boolState === false ? null : deleteFileHandler}
                    showBorderOnNoFiles={true}
                    multiple={true}
                    APIUrl={BASE_API_URL_BOXR}
                    isDeleting={loading === "file-deleting"}
                    uploadButtonView={boolState === false}
                    // name={"certificates[]"}
                    action={"Upload Document"} />


                {boolState === true && (
                    <div className={classes.actionButtons}>
                        <MROButton variant={"contained"}
                            onClick={handleClose}>
                            Cancel
                        </MROButton>
                        <MROButton
                            loading={loading === "file_upload"}
                            variant={"contained"}
                            color={"primary"}
                            type={"submit"}
                        >
                            Complete
                        </MROButton>
                    </div>


                )}
            </form>











        </ScopeDialog>
    )
}

export default TraceDocuments